import styled from 'styled-components';

export const StyledAppLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .app-layout__body {
    display: flex;
    flex-direction: row;
    flex: 1;
    overflow: hidden;
  }

  .app-layout__content {
    flex: 1;
    background: ${(props): string => props.theme.colors.white};
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;

    &:has(.app-layout-grey) {
      background: ${(props): string => props.theme.kcc.colors.BG_LAYOUT};
    }
  }
`;
